import { useNavigate } from "react-router-dom";
import axios from "axios";
import { generateUsername } from "unique-username-generator";
import { useDispatch } from "react-redux";
import { notification } from "antd";
import { __hideLoader, __showLoader } from "../Redux Store/Slices/loader";
import { AuthUrl } from "../urls";
import moment from "moment";
import { setTokens } from "../Redux Store/Slices/auth";
import { tempToast } from "../utils/toasts";

const useRegistrationForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const handleSubmit = async (values) => {

        tempToast();
        return;

        const dob = moment(values.dob).format("YYYY-MM-DD")
        dispatch(__showLoader("Signup..."));
        const data = {
            // username: generateUsername("-", 2, 20, values.name.split(" ")?.[0]),
            email: values.email,
            phone: values.phoneNumber,
            name: values.name,
            role: "STUDENT",
            // birthdate: dob,
            phone: "+14155552671",
            password: values.password
        };
        console.log({ values, data });


        try {
            const response = await axios.post(AuthUrl.signup, data);
            api.open({
                message: "Notification",
                description: "Signup successful!",
                duration: 0,
            });
            console.log("response")
            console.log(response.data);
            dispatch(setTokens({
                access_token: response.data.accessToken,
                refresh_token: response.data.accessToken,
            }));
            navigate("/dashboard/")
            // navigate("/otp-verification", { state: { phoneNumber: values.phoneNumber } });
        } catch (error) {
            let errorMessage = "Something Went Wrong";
            if (Array.isArray(error?.response?.data?.message)) {
                errorMessage = error?.response?.data?.message?.join?.(", ");
            } else {
                errorMessage = error?.response?.data?.message;
            }
            api.open({
                message: "Error",
                description: errorMessage,
                duration: 0,
            });
        } finally {
            dispatch(__hideLoader());
        }
    };

    return { handleSubmit, contextHolder };
};

export default useRegistrationForm;